import { useState } from 'react'

/**
 *  @typedef {import('../../utilities/objectStructures/globalStructures').SmartAccordionVisibility} SmartAccordionVisibility SmartAccordionVisibility object
 */

const useToggleSmartAccordionVisibility = () => {
  const [smartAccordionVisibility, setSmartAccordionVisibility] = useState([])

  /**
   * Get the visibility of a indicated id value
   * @param {number} id id number to search
   * @returns
   */
  const getSmartAccordionVisibility = (id) => {
    const visibility = smartAccordionVisibility.find((item) => item.id === id)
    return visibility ? visibility.visible : false
  }

  /**
   * Get the addMode of a indicated id value
   * @param {number} id id number to search
   * @returns
   */
  const getSmartAccordionAddMode = (id) => {
    const addMode = smartAccordionVisibility.find((item) => item.id === id)
    return addMode ? addMode.addMode : false
  }

  /**
   * Toggle the visibility of a indicated id value
   * @param {number} id id number to search
   */
  const toggleVisibility = (id) => {
    setSmartAccordionVisibility((prev) => {
      const exists = prev.find((item) => item.id === id)
      if (exists) {
        return prev.map((item) =>
          item.id === id
            ? { ...item, visible: !item.visible, addMode: false }
            : item
        )
      }
      return [...prev, { id, visible: true, addMode: false }]
    })
  }

  /**
   * Set accordion of a indicated id value
   * @param {number} id id number to search
   * @param {Boolean} visibility visibility value
   * @param {Boolean} newAddMode add mode value
   */
  const setAccordion = (id, visibility, newAddMode) => {
    setSmartAccordionVisibility((prev) => {
      const exists = prev.find((item) => item.id === id)
      if (exists) {
        return prev.map((item) =>
          item.id === id
            ? { ...item, visible: visibility, addMode: newAddMode }
            : item
        )
      }
      return [...prev, { id, visible: visibility, addMode: newAddMode }]
    })
  }

  return { getSmartAccordionVisibility, getSmartAccordionAddMode, toggleVisibility, setAccordion }
}

export default useToggleSmartAccordionVisibility
